import { Headline } from "@src/components/headline";
import { Tabs } from "antd";
import "./employee_data_page.less";
import { DepartmentDataTable } from "@src/features/employee_management/components/department_data_table";
import { EmployeeManagementTable } from "@src/features/employee_management/components/employee_management_table";

const EmployeeDataPage = () => {
  const tabs = [
    {
      key: "1",
      label: "Employees",
      children: <EmployeeManagementTable />,
    },
    {
      key: "2",
      label: "Departments",
      children: <DepartmentDataTable />,
    },
  ];

  return (
    <div className="employee-data-page">
      <Headline title="Employee data" />
      <span data-testid="label">
        Add or edit employees, assign roles and view employee details
      </span>
      <Tabs
        type="card"
        size="large"
        className="old-design"
        items={tabs}
        destroyOnHidden
      />
    </div>
  );
};

export default EmployeeDataPage;
